import style from './wallex-text.module.scss'
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const WallexText = (props: any) => {
    let { state } = props;
    return (
        <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
                if (inView) {
                    entry?.target.classList.add(animations.active);
                }
                return (
                    <>
                        <div ref={ref} className={`${style.wallex__text} ${animations.scroll__animation}`}>
                            {state}
                        </div>
                    </>
                )
            }}
        </InView>
    )


}

export default WallexText;
